import {SemanticLegendByMetric} from '../../../../../generated/graphql';
import {
  SemanticLegendSettingsWithCategoricalConfig,
  YAxisValues,
} from '../../types';
import {DEFAULT_SEMANTIC_LEGEND_SETTINGS} from '../SemanticLegendDefaults';
import {SemanticLegendPalette} from './colorPalettes';
import {parseBucketsFromSemanticLegendByMetric} from './parseBuckets';

export function constructSemanticLegendDataWithCategoricalConfig(
  getSemanticLegendPalette: (yAxisValue: YAxisValues) => SemanticLegendPalette,
  currentKey?: string,
  semanticLegendsByMetric?: SemanticLegendByMetric[]
): SemanticLegendSettingsWithCategoricalConfig {
  if (!semanticLegendsByMetric || !currentKey) {
    return DEFAULT_SEMANTIC_LEGEND_SETTINGS;
  }

  const currentLegend = semanticLegendsByMetric?.find(
    legend => legend?.metricName === currentKey
  );
  if (currentLegend) {
    const {buckets, bucketCustomizations} =
      parseBucketsFromSemanticLegendByMetric(
        currentLegend,
        getSemanticLegendPalette(currentLegend?.yValue as YAxisValues)
      );
    const yAxisValue =
      (currentLegend?.yValue as YAxisValues) ??
      DEFAULT_SEMANTIC_LEGEND_SETTINGS.yAxisValue;
    const categories = currentLegend?.categories ?? [];

    // For category-based configs, numberOfBuckets should be based on categories length or default
    // For numeric configs, it should be based on buckets.length
    const numberOfBuckets =
      yAxisValue === YAxisValues.Config_Categories
        ? categories.length > 0
          ? categories.length
          : DEFAULT_SEMANTIC_LEGEND_SETTINGS.numberOfBuckets
        : buckets.length > 0
          ? buckets.length
          : DEFAULT_SEMANTIC_LEGEND_SETTINGS.numberOfBuckets;

    return {
      bucketCustomizations: bucketCustomizations,
      buckets: buckets,
      excludedRunColor: currentLegend?.excludedRunColor ?? '',
      key: currentLegend?.metricName ?? '',
      numberOfBuckets: numberOfBuckets,
      selectedCategories: categories,
      yAxisValue: yAxisValue,
    };
  }
  return DEFAULT_SEMANTIC_LEGEND_SETTINGS;
}
